import { walletPaidAmount } from '../../utils/walletPayment'

const toNumber = value => {
  const n = Number(value)
  return isNaN(n) ? 0 : n
}

export function formatAmount(value) {
  return toNumber(value).toLocaleString('es-AR')
}

export function passengerBreakdown(passenger) {
  const companion = (passenger && passenger.companion) || {}
  const transaction = passenger && passenger.transaction
  const toDriver = toNumber(companion.price)
  const fee = toNumber(companion.fee)
  const discount = toNumber(companion.discount)

  const charged =
    transaction &&
    transaction.payment &&
    transaction.payment.transaction_details &&
    transaction.payment.transaction_details.total_paid_amount

  const chargedAmount = Math.max(0, toNumber(charged))
  const wallet = walletPaidAmount(transaction)
  const paid = chargedAmount + wallet
  const derived = toDriver + fee - discount

  return {
    seats: companion.seats == null ? null : toNumber(companion.seats),
    coupon: companion.coupon_code || null,
    toDriver,
    fee,
    discount,
    wallet,
    total: paid > 0 ? paid : derived > 0 ? derived : null,
    estimated: !(paid > 0)
  }
}
